import { useAppContext } from "../context/appContext";
import { useAppIssueContext } from "../context/appIssueContext";
import Message from "./Message";

export default function Messages(props) {
  const { loadingInitial, error, getMessagesAndSubscribe, messages } = useAppContext();
  const { username } = useAppIssueContext();
  const reversed = [...messages].reverse();
  if (loadingInitial)
    return (
      <div>
        <div />
      </div>
    );
  if (error)
    return (
      <div status="error" mt="20px">
        {error}
        <button ml="5px" onClick={getMessagesAndSubscribe} colorScheme="red" variant="link">
          try to reconnect
        </button>
      </div>
    );

  if (!messages.length) return <div as="h3">No responses 😞</div>;

  return reversed.map((message) => {
    const isYou = message.username === username;
    return <Message key={message.id} message={message} isYou={isYou} />;
  });
}
